module.exports = __webpack_public_path__ + "static/L5Y6-bc37132faddf75bc8472476965334ab9.jpg";